// Frontend display config. Server is source of truth for prices.
export const PRODUCT_IMAGES = {
  superq_5w30_c3: "/products/5w30-c3.png",
  superq_10w30: "/products/10w30.png",
  superq_10w40: "/products/10w40.png",
};

export const PRODUCT_SUBTITLE = {
  superq_5w30_c3: "Fully Synthetic",
  superq_10w30: "Semi Synthetic",
  superq_10w40: "Semi Synthetic",
};

// Volume + pack labels (customer-facing packaging info)
export const PRODUCT_VOLUME = {
  superq_5w30_c3: "18L",
  superq_10w30: "20L",
  superq_10w40: "18L",
};
export const PRODUCT_PACK = {
  superq_5w30_c3: "6L × 3 Bottles",
  superq_10w30: "20L Container",
  superq_10w40: "6L × 3 Bottles",
};

// Pickup identifiers (visible on cards, success page, staff page, SMS)
export const PICKUP_CODE = {
  superq_5w30_c3: "A1",
  superq_10w30: "A2",
  superq_10w40: "A3",
};
export const PICKUP_COLOR = {
  superq_5w30_c3: "BLUE",
  superq_10w30: "ORANGE",
  superq_10w40: "GREEN",
};

// Tailwind classes for the pickup badge (dark UI, high contrast)
export const PICKUP_BADGE_CLASS = {
  superq_5w30_c3: "bg-blue-500/15 text-blue-300 border-blue-500/40",
  superq_10w30: "bg-orange-500/15 text-orange-300 border-orange-500/40",
  superq_10w40: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
};

// Static ordering so success page can always list all products.
export const PRODUCT_ORDER = ["superq_5w30_c3", "superq_10w30", "superq_10w40"];

export const PRODUCT_SHORT_LABEL = {
  superq_5w30_c3: "5W-30 C3",
  superq_10w30: "10W-30",
  superq_10w40: "10W-40",
};

// Full packaging label used in success page rows and SMS body.
export const PRODUCT_PACK_LABEL = {
  superq_5w30_c3: "18L / 6L × 3 Bottles",
  superq_10w30: "20L Container",
  superq_10w40: "18L / 6L × 3 Bottles",
};

export const PRODUCT_PRICE = {
  superq_5w30_c3: 130,
  superq_10w30: 100,
  superq_10w40: 110,
};

export const GRADE_DOT = {
  superq_5w30_c3: "bg-[rgb(var(--grade-blue))]",
  superq_10w30: "bg-[rgb(var(--grade-orange))]",
  superq_10w40: "bg-[rgb(var(--grade-green))]",
};

export const formatAUD = (n) =>
  new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits: 2,
  }).format(n || 0);

export const formatAUDShort = (n) => {
  const v = Number(n || 0);
  if (Number.isInteger(v)) return `$${v}`;
  return `$${v.toFixed(2)}`;
};
